/* eslint-disable max-classes-per-file */
export interface RequestRewardSurveyInterface {
  AccountId: string | undefined;
  AcceptLanguage: string;
}

export class DataAnswersRewardSurveyInterface {
  question: string;

  questionText1: string;

  questionText2: string;

  questionText3: string;

  answerMax: number;

  answers: string[];

  questionId: number;

  questionKey: string;

  constructor(data: any) {
    this.answerMax = data?.answerMax || 1;
    this.answers = data?.answers || [""];
    this.question = data?.question || "";
    this.questionId = data?.questionId || 0;
    this.questionKey = data?.questionKey || "";
    this.questionText1 = data?.questionText1 || "";
    this.questionText2 = data?.questionText2 || "";
    this.questionText3 = data?.questionText3 || "";
  }
}

export class ResponseRewardSurveyInterface {
  status: boolean;

  message: string;

  data: {
    surveys: DataAnswersRewardSurveyInterface[];
  };

  constructor(data: any) {
    this.status = data.status || "";
    this.message = data.message || "";
    this.data = {
      surveys: (data?.data?.surveys || []).map(
        (e: DataAnswersRewardSurveyInterface) =>
          new DataAnswersRewardSurveyInterface(e),
      ),
    };
  }
}
